import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class BonusTicketService {
    title?: string;
    text?: string;
    topic?: string;
    isBonus = true;
}
